import React from 'react';
import { render } from 'react-dom';

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux'
import store, { history } from './store';

import MainRouter from './modules/MainRouter';

// eslint-disable-next-line no-undef
render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MainRouter />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('app-root')
);



// WEBPACK FOOTER //
// ./src/index.js